import React  from 'react';
import { Route,Switch} from 'react-router-dom';

import Staff from './Staff';
import StaffAddEdit from './Staff/addEdit';  
 
import StaffType from './StaffType';
import StaffTypeAddEdit from './StaffType/addEdit';  
export  const Staffroutes = [
    {
        path: '/staff',
        name:'Staff',
        component: Staff,
        show:true,
    },
    {
        path: '/staff-action',
        component: StaffAddEdit
    },
    {
        path: '/staff-action/:id', 
        component: StaffAddEdit
    },
    {
        path: '/staff-type',
        name:'Staff Type',
        component: StaffType,
        show:true,
    },
    {
        path: '/staff-type-action',
        component: StaffTypeAddEdit
    },
    {
        path: '/staff-type-action/:id', 
        component: StaffTypeAddEdit
    }   
];

const Staffs = (props) => {
    return(
        <Switch>
            {Staffroutes.map((route) => 
                <Route exact
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default Staffs; 


// WEBPACK FOOTER //
// ./src/components/Staff/index.js